import React from "react";
import { Box } from "@mantine/core";
import { TeethChoice } from "components/DentalArchesSvg";

export interface LegendProps {
  teethChoices: TeethChoice[];
}

export const Legend = ({ ...props }: LegendProps) => {
  return (
    <Box>
      {props.teethChoices.map(t => (
        <div
          key={`legend-${t.key}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            lineHeight: "normal",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              width: 30,
              height: 30,
              backgroundColor: t.color,
              borderRadius: 50,
            }}
          ></div>
          <p
            style={{
              margin: 0,
            }}
          >
            <span
              style={{
                fontWeight: 600,
                color: "#3C61E3",
              }}
            >
              {t.label}
            </span>
            <br />
            {t.description && t.description}
          </p>
        </div>
      ))}
    </Box>
  );
};
